import React from "react";
import { Security } from "@okta/okta-react";
import { oktaAuth } from "../okta/oktaconfig";
import { OktaAuthProvider } from "../okta/oktaauthprovider";

export const OktaBootstrap: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    const restoreOriginalUri = async (_oktaAuth: any, originalUri?: string) => {
        window.location.replace(originalUri || "/");
    };

    return (
        <Security
            oktaAuth={oktaAuth}
            restoreOriginalUri={restoreOriginalUri}
        >
            <OktaAuthProvider>
                {children}
            </OktaAuthProvider>
        </Security>
    );
};